import { object, string } from 'yup';

import CardVal from 'card-validator';

export default object().shape({
  display_number: string()
    .min(16, 'Mínimo 16 digitos')
    .test('number', 'Número de cartão inválido', (value) =>
      value ? CardVal.number(value).isPotentiallyValid : false
    )
    .required('É necessário inserir um número'),
  expiration_date: string()
    .test('number', 'Data de vencimento inválida', (value) =>
      value ? CardVal.expirationDate(value).isValid : false
    )
    .required('O vencimento é obrigatório'),
  cvv: string()
    .test(
      'number',
      'Verifique o CVV digitado',

      (value) =>
        value
          ? value.length > 3
            ? CardVal.cvv(value, 4).isValid
            : CardVal.cvv(value).isValid
          : false
    )
    .required('O CVV é obrigatório'),
  holder_name: string().required('O nome do titular é obrigatório'),
});
